module.exports = __webpack_public_path__ + "static/media/ai4-bg.e0f218b3.jpg";